<template>
  <v-card>
    <v-card-text>
        <v-form v-model="valid">
            <v-text-field v-if="competition != null" v-model="competition.title" label="Title"/>
            <v-text-field v-if="competition != null" v-model="competition.longTitle" label="Long title"/>
            <v-text-field v-if="competition != null" v-model="competition.location" label="Location"/>
            <v-text-field v-if="competition != null" v-model="competition.organizer.name" label="Organizer" disabled/>
            <FCCDate :source="this.competition" propertyName="start" :label="this.$t('dashboard.competitionStart')" :required="true" />
            <FCCDate :source="this.competition" propertyName="end" :label="this.$t('dashboard.competitionEnd')" :required="true" />
            <v-checkbox v-if="competition != null" color="red" v-model="competition.public" label="Public"></v-checkbox>
        </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="saveDetails()" color="success">
        {{ $t("ctrl.save") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
  } from 'vuetify/lib'
  import FCCDate from '../../widgets/FCCDate'
  import fccapi from '../../fccapi.js'

  export default {
    name: 'FCCCompetitionDetails',
    data: () => ({
      competition: null,
      valid: false
    }),
    computed: {
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      },
      selectedCompetition: function() {
        return this.$store.getters['competitionId'];
      }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        FCCDate
    },
    methods: {
      saveDetails: function () {
        fccapi.post(`competitions/${this.competition.id}`, this.competition).then(d => {
            this.$store.dispatch('loadBaseData').then(e => {
              console.log("Base data loaded")
              this.competition = this.$store.getters.competition;
            }).catch(() => {
              console.log("Couldn't load base data")
            })
          }).catch(e => {
            console.log(e)
          })
      }
    },
    mounted: function(){
      this.competition = JSON.parse(JSON.stringify(this.$store.getters.competition));
    },
    watch: {
      selectedCompetition() {
        console.log("changed")
        this.competition = JSON.parse(JSON.stringify(this.$store.getters.competition));
      }
    }
  }
</script>